import CardImg1 from '../../graphics/imagenes/productos/torgelon.jpeg';
import CardImg2 from '../../graphics/imagenes/productos/loscalvos42.jpeg';
import CardImg3 from '../../graphics/imagenes/productos/elartesano.jpeg';
import CardImg4 from '../../graphics/imagenes/productos/tudor.jpeg';
import CardImg5 from '../../graphics/imagenes/productos/torgelonblanco.jpeg';
import CardImg6 from '../../graphics/imagenes/productos/loscalvosblanco.jpg'
import CardImg7 from '../../graphics/imagenes/productos/elartesanoblanco.jpeg'
import CardImg8 from '../../graphics/imagenes/productos/tudorblanco.jpeg'


const ImgCard = [
    {
        id:"1",
        img: CardImg1,
        title: "torgelon",
        instalments: "24 meses",
    },
    {
        id:"2",
        img: CardImg2,
        title: "los calvos",
        instalments: "24 meses",
    },
    {
        id:"3",
        img: CardImg3,
        title: "el artesano",
        instalments: "24 meses",
    },
    {
        id:"4",
        img: CardImg4,
        title: "tudor",
        instalments: "24 meses",
    },
    {
        id:"5",
        img: CardImg5,
        title: "torgelon",
        instalments: "13 meses",
    },
    {
        id:"6",
        img: CardImg6,
        title: "los calvos",
        instalments: "13 meses",
    },
    {
        id:"7",
        img: CardImg7,
        title: "el artesano",
        instalments: "13 meses",
    },
    {
        id:"8",
        img: CardImg8,
        title: "tudor",
        instalments: "13 meses",
    },
 ];

 export default ImgCard;
